import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { ToastrService } from "ngx-toastr";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { isUndefined, isNullOrUndefined, isNull } from "util";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";
import { DatePipe } from "@angular/common";
import { HrEmpAdddressDetails } from "../../shared/models/HrEmpAddressDetails";
import { HREmployeeDetails } from "../../shared/models/hremployeecommunicationdetails.model";
import { File_Types } from "../../shared/UploadFileTypes";
import { UserService } from "../../shared/service/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { DepartmentsService } from "../../shared/service/departments.service";
const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-hr-emp-communication-details",
  templateUrl: "./hr-emp-communication-details.component.html",
  styleUrls: ["./hr-emp-communication-details.component.css"],

  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class HrEmpCommunicationDetailsComponent implements OnInit, OnChanges {
  @Input() empCode: number;
  @Input() groupId: string;
  @Output("employeeDet") employeeDet = new EventEmitter();
  error: any;
  employeeDetails: any;
  originalEmpCommunicationDetails: any;
  date: Date;
  todayDate: Date;
  datePipe: DatePipe;
  setDob: string;
  isLoader: boolean = true;
  AddressSame: boolean = false;
  showValidation: boolean;
  gettingBasicDet: BasicEmployeeDetails;
  EmpAddform: FormGroup;
  LoginEmpCode: any;
  isProfile: boolean;
  approveCheckMyProfile: any;
  disableforMyProfile: boolean;
  eeTypeList: any;
  teamList: any;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    public router: Router,
    public _service: OnboardingService,
    public toastr: ToastrService,
    public file_Svc: FileUploadService,
    private emp_Svc: EmployeeService,
    private deptSvc: DepartmentsService
  ) {
    this.todayDate = new Date();
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
      this.initializeParamChange();
    });
  }
  initializeParamChange() {
    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    if (!isNullOrUndefined(this.empCode)) {
      if (this.router.url.startsWith("/myprofile/")) {
        if (this.empCode === this.LoginEmpCode) this.isProfile = true;
        else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
  }

  ngOnInit() {
   // this.getSubmitMyProfileData();
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }

  ngOnChanges() {
    this.deptSvc.fetchAndCacheEeTypeList('Team').subscribe((teamList) => {
      this.teamList = teamList.filter(
        (team) => team.Value != "Onshore"
      );
    });
    this.deptSvc.fetchAndCacheEeTypeList('EeType').subscribe((eeTypeList) => { this.eeTypeList = eeTypeList });
    this.employeeDetails = new HREmployeeDetails();
    this.FormInitialization();
    this.getBasicEmployeeByCode();
    if (!isUndefined(this.groupId)) {
      this.getBasicEmployeeByGroupId();
      this.getCommunicationDataByGroupId();
    }
    if (!isUndefined(this.empCode)) {
      this.getCommunicationData();
    } else {
      this.employeeDet.emit(this.employeeDetails);
    }
  }
  FormInitialization() {
    this.EmpAddform = new FormGroup({
      City: new FormControl(),
      District: new FormControl(),
      State: new FormControl(),
      Country: new FormControl(),
      PinCode: new FormControl(),
      HouseNo: new FormControl(),
      StreetName: new FormControl(),
      PCity: new FormControl(),
      PDistrict: new FormControl(),
      PState: new FormControl(),
      PCountry: new FormControl(),
      PPinCode: new FormControl(),
      PHouseNo: new FormControl(),
      PStreetName: new FormControl(),
      AddressCB: new FormControl(),
    });
  }
  getSubmitMyProfileData() {
    this.emp_Svc
      .GetProfileVerificationStatus(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.approveCheckMyProfile = data;
        if (this.isProfile == true) {
          for (var i = 0; i < data.length; i++) {
            this.disableforMyProfile = data[i].Submitted;
          }
        }
        if (this.disableforMyProfile == true) {
          this.EmpAddform.disable();
        }
      });
  }
  getDataChanged(data: any) {
    if (this.employeeDetails.TemporaryAddress.IsAddressSame) {
      if (!isNullOrUndefined(data)) {
        this.employeeDetails.PermanentAddress =
          this.employeeDetails.TemporaryAddress;
      }
    }
  }

  //getTeams() {
  //  this.deptSvc.getMasterGroupByCategory("Team").subscribe((data: any) => {
  //    this.deptSvc
  //      .getMasterGroupByGroupID(data[0].ID)
  //      .subscribe((dataList: any) => {
  //        this.teamList = dataList;
  //        this.teamList = this.teamList.filter(
  //          (team) => team.Value != "Onshore"
  //        );
  //      });
  //  });
  //}

  getEmployeeTypeValue(Id) {
    if (this.eeTypeList != null) {
      for (var i = 0; i < this.eeTypeList.length; i++) {
        if (this.eeTypeList[i].ID == Id) return this.eeTypeList[i].Value;
      }
    }
  }

  //getEeType() {
  //  this.deptSvc.getMasterGroupByCategory("EeType").subscribe((data: any) => {
  //    this.deptSvc
  //      .getMasterGroupByGroupID(data[0].ID)
  //      .subscribe((dataList: any) => {
  //        this.eeTypeList = dataList;
  //      });
  //  });
  //}

  getTeamValue(Id) {
    if (this.teamList != null) {
      for (var i = 0; i < this.teamList.length; i++) {
        if (this.teamList[i].ID == Id) {
          return this.teamList[i].Value;
        }
      }
    }
  }

  getBasicEmployeeByGroupId() {
    if (this.empCode != null) {
      this.emp_Svc
        .getEmployeeDetailsByGroupId(this.groupId)
        .subscribe((data: any) => {
          this.gettingBasicDet = data;
          if (
            this.gettingBasicDet.LocationID != null &&
            this.gettingBasicDet.LocationID != 1 &&
            this.gettingBasicDet.LocationID != 2
          ) {
            this.showValidation = false;
          } else {
            this.showValidation = true;
          }
        });
    }
  }

  getBasicEmployeeByCode() {
    if (this.empCode != null) {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
        this.gettingBasicDet = data;
        if (
          this.gettingBasicDet &&
          this.gettingBasicDet.LocationID != null &&
          this.gettingBasicDet.LocationID != 1 &&
          this.gettingBasicDet.LocationID != 2
        ) {
          this.showValidation = false;
        } else {
          this.showValidation = true;
        }
      });
    }
  }

  getObjectState() {
    const originalEmp = this.originalEmpCommunicationDetails;
    const currentEmp = this.employeeDetails;

    return !(JSON.stringify(originalEmp) == JSON.stringify(currentEmp));
  }

  getRefreshPage() {
    window.location.reload();
  }

  getCommunicationData() {
    if (this.empCode != null) {
      this.emp_Svc.getEmployeeDetails(this.empCode).subscribe(
        (data: any) => {
          this.employeeDetails = data;
          if (isNullOrUndefined(this.employeeDetails.TemporaryAddress)) {
            this.employeeDetails.TemporaryAddress = new HrEmpAdddressDetails();
            this.employeeDetails.TemporaryAddress.IsAddressSame = false;
          }
          if (this.employeeDetails.TemporaryAddress.IsAddressSame) {
            this.AddressSame = true;
            this.disablePermanentAddressFields();
          }
          if (this.employeeDetails.TemporaryAddress.IsAddressSame) {
            this.AddressSame = true;
            this.disablePermanentAddressFields();
          }
          if (isNullOrUndefined(this.employeeDetails.PermanentAddress)) {
            this.employeeDetails.PermanentAddress = new HrEmpAdddressDetails();
          }
          if (isNullOrUndefined(this.employeeDetails.TemporaryAddress)) {
            this.employeeDetails.TemporaryAddress = new HrEmpAdddressDetails();
            this.employeeDetails.TemporaryAddress.IsAddressSame = false;
          }
          //else {

          if (this.employeeDetails.TemporaryAddress.IsAddressSame) {
            this.AddressSame = true;
            this.disablePermanentAddressFields();
          } else {
            this.enablePermanentAddressFields();
          }

          //}
          if (isNullOrUndefined(this.employeeDetails.PermanentAddress)) {
            this.employeeDetails.PermanentAddress = new HrEmpAdddressDetails();
          }
          this.originalEmpCommunicationDetails = JSON.parse(
            JSON.stringify(data)
          );
          this.employeeDet.emit(this.employeeDetails);
        },
        (error) => (this.error = error)
      );
    }
  }

  getCommunicationDataByGroupId() {
    if (this.groupId != null) {
      this.emp_Svc.getHREmployeeGroupDetails(this.groupId).subscribe(
        (data: any) => {
          this.employeeDetails = data;
          if (isNullOrUndefined(this.employeeDetails.TemporaryAddress)) {
            this.employeeDetails.TemporaryAddress = new HrEmpAdddressDetails();
            this.employeeDetails.TemporaryAddress.IsAddressSame = false;
          }
          if (this.employeeDetails.TemporaryAddress.IsAddressSame) {
            this.AddressSame = true;
            this.disablePermanentAddressFields();
          }
          if (this.employeeDetails.TemporaryAddress.IsAddressSame) {
            this.AddressSame = true;
            this.disablePermanentAddressFields();
          }
          if (isNullOrUndefined(this.employeeDetails.PermanentAddress)) {
            this.employeeDetails.PermanentAddress = new HrEmpAdddressDetails();
          }
          if (isNullOrUndefined(this.employeeDetails.TemporaryAddress)) {
            this.employeeDetails.TemporaryAddress = new HrEmpAdddressDetails();
            this.employeeDetails.TemporaryAddress.IsAddressSame = false;
          }
          //else {

          if (this.employeeDetails.TemporaryAddress.IsAddressSame) {
            this.AddressSame = true;
            this.disablePermanentAddressFields();
          } else {
            this.enablePermanentAddressFields();
          }

          //}
          if (isNullOrUndefined(this.employeeDetails.PermanentAddress)) {
            this.employeeDetails.PermanentAddress = new HrEmpAdddressDetails();
          }
          this.originalEmpCommunicationDetails = JSON.parse(
            JSON.stringify(data)
          );
          this.employeeDet.emit(this.employeeDetails);
        },
        (error) => (this.error = error)
      );
    }
  }

  copyTempAddr(event: any) {
    //alert(this.employeeDetails.TemporaryAddress);
    if (event.checked && this.employeeDetails.TemporaryAddress != null) {
      this.employeeDetails.TemporaryAddress.IsAddressSame = true;
      this.disablePermanentAddressFields();
      this.employeeDetails.PermanentAddress =
        this.employeeDetails.TemporaryAddress;
    } else {
      this.employeeDetails.TemporaryAddress.IsAddressSame = false;
      this.enablePermanentAddressFields();
      this.employeeDetails.PermanentAddress = new HrEmpAdddressDetails();
    }
  }
  disablePermanentAddressFields() {
    this.EmpAddform.get("PCity").disable();
    this.EmpAddform.get("PDistrict").disable();
    this.EmpAddform.get("PState").disable();
    this.EmpAddform.get("PCountry").disable();
    this.EmpAddform.get("PPinCode").disable();
    this.EmpAddform.get("PHouseNo").disable();
    this.EmpAddform.get("PStreetName").disable();
  }
  enablePermanentAddressFields() {
    this.EmpAddform.get("PCity").enable();
    this.EmpAddform.get("PDistrict").enable();
    this.EmpAddform.get("PState").enable();
    this.EmpAddform.get("PCountry").enable();
    this.EmpAddform.get("PPinCode").enable();
    this.EmpAddform.get("PHouseNo").enable();
    this.EmpAddform.get("PStreetName").enable();
  }
}
